import React, { useMemo } from "react";
import Translations from "../../services/translation.service";
import Helpers from "../../helpers/shared.helper";
import {
  buildAmanSocialSummaryVisuals,
  resolveAmanFeatureAttributes,
} from "../../helpers/aman-feature.helper";

const renderIconColumn = (rowKey, urls, variant) => {
  if (variant === "restricted" && urls.length === 1 && urls[0]) {
    return (
      <span className="stm-sum-aman-restricted-wrap">
        <img src={urls[0]} alt="" />
      </span>
    );
  }
  if (variant === "restricted" && urls.length > 1) {
    return (
      <div className="stm-sum-aman-icon-row stm-sum-aman-icon-row--overlap">
        {urls.map((url, idx) => (
          <span
            key={`${rowKey}-${idx}`}
            className="stm-sum-aman-icon-pile-item"
            style={{ zIndex: idx + 1 }}
          >
            <img src={url} alt="" />
          </span>
        ))}
      </div>
    );
  }
  if (urls?.length) {
    return (
      <div className="stm-sum-aman-icon-row stm-sum-aman-icon-row--overlap">
        {urls.map((url, idx) => (
          <span
            key={`${rowKey}-${idx}`}
            className="stm-sum-aman-icon-pile-item"
            style={{ zIndex: idx + 1 }}
          >
            <img src={url} alt="" />
          </span>
        ))}
      </div>
    );
  }
  return null;
};

const StmSummaryAmanFeatureRows = ({ planCode, planId, featureAttributes }) => {
  const currentLanguage = Translations.getCurrentLanguage();
  const bundle = useMemo(() => {
    const attrsFromApi =
      Array.isArray(featureAttributes) && featureAttributes.length
        ? featureAttributes
        : null;
    const attrs =
      attrsFromApi || resolveAmanFeatureAttributes({ planCode, planId, selectedCard: null });
    const getPoImage = (key) =>
      Helpers.getPOImageCommon("social_networks", key, currentLanguage, "");
    const visuals = buildAmanSocialSummaryVisuals(
      attrs,
      getPoImage,
      Translations.keys || {}
    );
    if (!visuals) return null;
    return { visuals };
  }, [planCode, planId, currentLanguage, featureAttributes]);

  if (!bundle) return null;

  const { visuals } = bundle;
  const keys = Translations.keys || {};
  const showBlocks = visuals.hasBlocked && visuals.blockedIconUrls.length > 0;
  const showRestricted = visuals.hasRestricted && visuals.restrictedIconUrls.length > 0;
  const showSafe = visuals.hasSafe;

  if (!showBlocks && !showRestricted && !showSafe) return null;

  return (
    <>
      {showBlocks && (
        <React.Fragment key="blocks">
          <div className="stm-sum-block-left stm-sum-aman-feature-label">
            {keys["stf_blocks_social_media"] || "Blocks social media"}
          </div>
          <div className="stm-sum-block-right stm-sum-aman-feature-rows">
            {renderIconColumn("blocks", visuals.blockedIconUrls)}
          </div>
        </React.Fragment>
      )}

      {showRestricted && (
        <React.Fragment key="restricted">
          <div className="stm-sum-block-left stm-sum-aman-feature-label">
            <span>{keys["stf_restricted_mode"] || "Restricted mode"}</span>
            {" "}
            {visuals.restrictedNames.join(", ")}
          </div>
          <div className="stm-sum-block-right stm-sum-aman-feature-rows">
            {renderIconColumn("restricted", visuals.restrictedIconUrls, "restricted")}
          </div>
        </React.Fragment>
      )}

      {showSafe && (
        <div
          key="safe"
          className="stm-sum-block-left stm-sum-aman-feature-label stm-sum-aman-feature-label--full-row"
        >
          <span>{keys["stf_safe_search"] || "Safe search"}</span>
          {" "}
          <span>{keys["stf_safe_search_sub"] || "enabled for major search engines"}</span>
        </div>
      )}
    </>
  );
};

export default StmSummaryAmanFeatureRows;
